<section id="main">
    <div class="mtn-title">
        <p>Partners Suite</p>
    </div>
    <div class="form-btns">
        <a (click)="onButtonClick()" class="btn btn2">Proceed to Partners Suite</a>
    </div>
</section>